import { h } from 'preact';
import { ListEntry } from '../entries/ListEntry';

const TASK_TYPES = ['epx:UserTask', 'epx:ServiceTask', 'epx:ScriptTask', 'epx:ManualTask'];

const COLUMNS = [
  { key: 'notificationType', label: 'Type' },
  { key: 'notificationText', label: 'Text' },
];

export class NotificationPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return TASK_TYPES.includes(elementType);
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const notifications = props.notifications || [];

    const updateNotifications = (items) => {
      lf.setProperties(id, { notifications: items });
      lf.emit('node:properties-change', { id, properties: { notifications: items } });
    };

    return [
      {
        id: 'notifications',
        label: i18n.notifications || 'Notifications',
        entries: [
          {
            id: 'notificationsList',
            component: () => (
              <ListEntry
                id="epx-notifications"
                label=""
                items={notifications}
                columns={COLUMNS}
                onAdd={() => updateNotifications([...notifications, { notificationType: 'Email', notificationText: '' }])}
                onRemove={(idx) => updateNotifications(notifications.filter((_, i) => i !== idx))}
                onChange={(idx, key, value) => {
                  const updated = notifications.map((n, i) => i === idx ? { ...n, [key]: value } : n);
                  updateNotifications(updated);
                }}
              />
            ),
          },
        ],
      },
    ];
  }
}
